"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkInvestInTriggerTPSL = exports.FUTURES_CONDITION_COMPARE_TO_TPSL = void 0;
const lodash_1 = require("lodash");
const GridTradingUtils_1 = require("../../GridTradingUtils");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
var FUTURES_CONDITION_COMPARE_TO_TPSL;
(function (FUTURES_CONDITION_COMPARE_TO_TPSL) {
    FUTURES_CONDITION_COMPARE_TO_TPSL[FUTURES_CONDITION_COMPARE_TO_TPSL["GREATER_THAN"] = 1] = "GREATER_THAN";
    FUTURES_CONDITION_COMPARE_TO_TPSL[FUTURES_CONDITION_COMPARE_TO_TPSL["LESS_THAN"] = -1] = "LESS_THAN";
    FUTURES_CONDITION_COMPARE_TO_TPSL[FUTURES_CONDITION_COMPARE_TO_TPSL["BETWEEN"] = 0] = "BETWEEN";
})(FUTURES_CONDITION_COMPARE_TO_TPSL || (exports.FUTURES_CONDITION_COMPARE_TO_TPSL = FUTURES_CONDITION_COMPARE_TO_TPSL = {}));
const shouldCancelTPSL = (order, triggerPrice) => {
    const price = new trade_utils_lib_1.SafeDecimal(triggerPrice);
    const stopProfit = new trade_utils_lib_1.SafeDecimal(order.trailing);
    const stopLoss = new trade_utils_lib_1.SafeDecimal(order.stop);
    const stopLossHigh = new trade_utils_lib_1.SafeDecimal(order.stopHigh);
    const res = {
        stopProfitTypeIsPrice: false,
        stopLossTypeIsPrice: false,
        compareToStopProfit: undefined,
        compareToStopLoss: undefined,
    };
    if (stopLoss.isZero() && stopProfit.isZero()) {
        return res;
    }
    // 按价格止盈
    if ((order.profit_stop_type === TradeAPILib_1.GridStopType.price || order.profit_stop_type === TradeAPILib_1.GridStopType.price_limit) && stopProfit.gt(0)) {
        // 中性，触发价在开单的格子区间内
        if (order.trend === TradeAPILib_1.GridFuturesTrend.no_trend) {
            const range = GridTradingUtils_1.GridTradingUtils.getNoTrendTPPriceRange({
                top: (0, lodash_1.toString)(order.high),
                bottom: (0, lodash_1.toString)(order.low),
                gridType: order.gridType,
                row: (0, lodash_1.toString)(order.number),
                price: (0, lodash_1.toString)(order.openInitPrice),
            });
            if (price.lte(new trade_utils_lib_1.SafeDecimal(range === null || range === void 0 ? void 0 : range.max)) && price.gte(new trade_utils_lib_1.SafeDecimal(range === null || range === void 0 ? void 0 : range.min))) {
                res.compareToStopProfit = FUTURES_CONDITION_COMPARE_TO_TPSL.BETWEEN;
            }
        }
        // 做多，触发价 ≥ 止盈触发价
        if (order.trend === TradeAPILib_1.GridFuturesTrend.long && price.gte(stopProfit)) {
            res.compareToStopProfit = FUTURES_CONDITION_COMPARE_TO_TPSL.GREATER_THAN;
        }
        // 做空，触发价 ≤ 止盈触发价
        if (order.trend === TradeAPILib_1.GridFuturesTrend.short && price.lte(stopProfit)) {
            res.compareToStopProfit = FUTURES_CONDITION_COMPARE_TO_TPSL.LESS_THAN;
        }
        res.stopProfitTypeIsPrice = !(0, lodash_1.isNil)(res.compareToStopProfit);
    }
    // 按价格止损
    if (order.loss_stop_type === TradeAPILib_1.GridStopType.price || order.loss_stop_type === TradeAPILib_1.GridStopType.price_limit) {
        // 做多，触发价 ≤ 止损触发价；中性，触发价 ≤ 下跌止损触发价
        if (stopLoss.gt(0) &&
            ((order.trend === TradeAPILib_1.GridFuturesTrend.long && price.lte(stopLoss)) ||
                (order.trend === TradeAPILib_1.GridFuturesTrend.no_trend && price.lte(stopLoss)))) {
            res.compareToStopLoss = FUTURES_CONDITION_COMPARE_TO_TPSL.LESS_THAN;
        }
        // 做空，触发价 ≥ 止损触发价；中性，或触发价 ≥ 上涨止损触发价
        else if ((stopLoss.gt(0) && order.trend === TradeAPILib_1.GridFuturesTrend.short && price.gte(stopLoss)) ||
            (stopLossHigh.gt(0) && order.trend === TradeAPILib_1.GridFuturesTrend.no_trend && price.gte(stopLossHigh))) {
            res.compareToStopLoss = FUTURES_CONDITION_COMPARE_TO_TPSL.GREATER_THAN;
        }
        res.stopLossTypeIsPrice = !(0, lodash_1.isNil)(res.compareToStopLoss);
    }
    return res;
};
const checkInvestInTriggerTPSL = ({ order, condition }) => {
    return order && condition ? shouldCancelTPSL(order, condition) : undefined;
};
exports.checkInvestInTriggerTPSL = checkInvestInTriggerTPSL;
